import React, { useEffect, useState } from 'react';
import TimelineCard from './TimelineCard';
// import { DateWithEvents , Event } from '../resources/data/itineraryInterfaces';
import { useRecoilState } from 'recoil';
import { topicsState } from '../recoil';
import {
    ConferenceSchedule,
    DateWithEvents,
    Event,
} from '../resources/data/itinerary-test-interfaces';
import VoiceItineraryTimelineCard from './VoiceItineraryTimelineCard';

interface AgendaProps {
  itinerary: ConferenceSchedule;
}

function VoiceItineraryAgenda({ itinerary }: AgendaProps) {
  const [groupedData, setGroupedData] = useState<DateWithEvents[]>([]);
  const [topics, setTopics] = useRecoilState(topicsState);

  const splitTopics = topics.split(',').map((t) => t.trimEnd());
  useEffect(() => {
    if (itinerary && itinerary.dates) {
      const groupedByDate = Object.values(
        itinerary.dates.reduce(
          (acc: { [key: string]: DateWithEvents }, item: DateWithEvents) => {
            const { date, events } = item;

            if (!acc[date]) {
              acc[date] = { date, events: [] };
            }

            acc[date].events.push(...events);

            return acc;
          },
          {}
        )
      );

      setGroupedData(groupedByDate);
    }
  }, [itinerary]);

  function formatDate(dateStr: string): string {
    const daysOfWeek = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const [monthStr, dayStr] = dateStr.split(' ');
    const monthIndex = months.indexOf(monthStr);
    const day = parseInt(dayStr, 10);

    const date = new Date(0, monthIndex, day);
    const dayOfWeek = daysOfWeek[date.getDay()];

    const suffix = getSuffix(day);

    return `${dayOfWeek}, ${monthStr} ${day}${suffix}`;
  }

  function getSuffix(day: number): string {
    const lastDigit = day % 10;
    const lastTwoDigits = day % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return 'th';
    }

    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  return (
    <div className="mb-8 px-4 flex w-full ">
      <div className="Agenda flex w-full flex-col items-start justify-start gap-6">
        {splitTopics.length > 0 && (
          <div>
            <div className={`flex flex-col md:flex-row w-full items-baseline gap-2`}>
              <div className="TopicsTitle flex font-['Graphik'] text-xl font-bold text-white ">
                Inspired By:
              </div>
              <div className="Topics flex flex-wrap gap-2">
                {splitTopics.map((t, i) => {
                  return (
                    <div className="ChipsEventTypeTime flex items-start justify-start gap-2" key={i}>
                      <div
                        className={`EventType flex items-center justify-center gap-2 rounded-md bg-white bg-opacity-10 p-2`}
                      >
                        <div
                          className={`Title font-['Graphik'] text-sm font-medium text-white`}
                        >
                          {t}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        <div className="DayBlock flex w-full flex-col items-start justify-start gap-4">
          {groupedData.map((dateObj: DateWithEvents, dateIndex: number) => (
            <div className=' flex flex-col gap-2 w-full' key={`date-${dateIndex}`}>
              <div className="Date flex items-start justify-start gap-2 md:pl-[4.75rem]">
                <div className="Thursday6th font-['Graphik'] text-xl font-bold text-white">
                  {formatDate(dateObj.date)}
                </div>
              </div>
              {dateObj.events.map((event: Event, eventIndex: number) => {
                return (
                  <div className='DayBlockRow w-full' key={`event-${eventIndex}`}>
                    <VoiceItineraryTimelineCard
                      eventName={event.eventName}
                      duration={event.duration}
                      location={event.location}
                      startTime={event.startTime}
                      endTime={event.endTime}
                      IlianaRecommendation={event.IlianaRecommendation}
                      TammyAndMattPick={event.TammyAndMattPick}
                      accenturePriority={event.accenturePriority}
                      interestMatch={event.interestMatch}
                      speaker={event.speaker}
                    />
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default VoiceItineraryAgenda;
